import React from 'react'

import Svg from './'

const SvgLicenseDriver = props => (
  <Svg viewBox="0 0 100 90.441" {...props}>
    <path d="M66.756,7.871a3.69,3.69,0,0,1,5.037,1.366h0L92.092,44.3a3.692,3.692,0,0,1-1.347,5.038L33.226,82.644a3.69,3.69,0,0,1-5.03-1.393L28.17,81.2,7.871,46.143A3.691,3.691,0,0,1,9.215,41.1l.022-.013L66.774,7.871M63.065,1.487,5.546,34.7A11.073,11.073,0,0,0,1.48,49.823l.007.011L21.785,84.9a11.072,11.072,0,0,0,15.121,4.066l.011-.006L94.454,55.739A11.073,11.073,0,0,0,98.52,40.618l-.007-.011L78.2,5.546A11.072,11.072,0,0,0,63.076,1.48Z" />
    <path d="M56.938,61.5,34.573,74.414,17.965,45.645,40.331,32.728ZM35.92,69.357,51.9,60.131,38.983,37.766,23,46.992Z" />
    <rect
      x="53.309"
      y="35.104"
      width="25.834"
      height="3.691"
      transform="translate(-9.602 38.063) rotate(-30)"
    />
    <rect
      x="56.994"
      y="41.517"
      width="25.834"
      height="3.691"
      transform="translate(-12.315 40.765) rotate(-30)"
    />
    <rect
      x="60.688"
      y="47.895"
      width="25.834"
      height="3.691"
      transform="translate(-15.009 43.467) rotate(-30)"
    />
  </Svg>
)

export default SvgLicenseDriver



// WEBPACK FOOTER //
// ../source/components/Svg/SvgLicenseDriver.js